export const trimHTML = (str: string, replaceWith = " ") => {
  const regex = /(<([^>]+)>)/gi;
  return str.replace(regex, replaceWith).trim();
};
